<template>
    <div class="parties_chart">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
    </div>
</template>

<script>
const formatCurrency = (input) => {
    if (input == null) return input;
    const str = String(input).trim();
    const num = Number(str);
    if (isNaN(num)) return input;
    const formatter = new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
    });
    return formatter.format(num);
};

export default {
    props: ["chart_data", "fiscal_years"],
    data() {
        return {
            active_data: null,
            chartOptions: {
                chart: {
                    showAxes: true,
                    marginRight: 0,
                    marginLeft: 5,
                    spacingRight: 0,
                    backgroundColor: null,
                    style: {
                        fontFamily: "CeraPro",
                    },
                },
                title: {
                    text: null,
                },
                yAxis: {
                    // visible: false,
                    gridLineColor: "#555",
                },

                xAxis: {
                    // lineColor : '#ededed',
                    categories: this.fiscal_years,
                    labels: {
                        style: {
                            color: "#fff",
                        },
                    },
                    stackLabels: {
                        enabled: true,
                        align: "center",
                        textOutline: 0,
                        valuePrefix: "€",
                    },
                },

                legend: {
                    align: "left",
                    verticalAlign: "bottom",
                    x: 0,
                    y: 0,
                    itemStyle: {
                        color: "#fff",
                        fontSize: "12px",
                        fontWeight: "normal",
                    },
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false,
                        },
                        // pointStart: this.chart_data.pointStart
                    },
                },
                tooltip: {
                    valueSuffix: "€",
                    backgroundColor: "#2a2a2a",
                    borderWidth: 0,
                    formatter: function () {
                        return (
                            formatCurrency(this.y) +
                            "<br />" +
                            '<span style="font-size: 0.8em; color: ' +
                            this.series.color +
                            ' ">' +
                            this.series.name +
                            " " +
                            this.x +
                            "</span>"
                        );
                    },
                    style: {
                        color: "#fff",
                    },
                },

                series: [
                    {
                        color: "#8bffcc",
                        name: "ΕΙΣΟΔΗΜΑΤΑ",
                    },
                    {
                        color: "#ffc6be",
                        name: "ΚΑΤΑΘΕΣΕΙΣ",
                    },
                    {
                        color: "#b3af73",
                        name: "ΔΑΝΕΙΑ ΟΦΕΙΛΕΣ",
                    },
                ],

                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500,
                            },
                            chartOptions: {
                                legend: {
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                },
                            },
                        },
                    ],
                },
            },
        };
    },
    mounted() {
        this.chartOptions.series = this.chart_data.series;
    },
    methods: {
        seprator(input) {
            let nums = input.replace(/,/g, "");
            if (!nums || nums.endsWith(".")) return;
            return parseFloat(nums).toLocaleString();
        },
    },
};
</script>
<style lang="scss">
.highcharts-credits {
    display: none;
}
</style>
